/**
 * Billing Service
 * 
 * Handles Stripe billing and subscription-related API calls.
 * Endpoints: /api/billing/*
 */

export const billingService = {
    /**
     * Create Stripe checkout session
     */
    async createCheckout(tier) {
        try {
            const response = await fetch('/api/billing/checkout', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ tier })
            });

            if (!response.ok) {
                return { ok: false, error: 'Failed to create checkout session' };
            }

            const data = await response.json();
            return { ok: true, url: data.url };
        } catch (error) {
            console.error('Checkout error:', error);
            return { ok: false, error: error.message };
        }
    },

    /**
     * Get Stripe Customer Portal URL
     */
    async getPortalUrl() {
        try {
            const response = await fetch('/api/billing/portal', {
                method: 'GET',
                credentials: 'include'
            });

            if (!response.ok) {
                return { ok: false, error: 'Failed to get portal URL' };
            }

            const data = await response.json();
            return { ok: true, url: data.url };
        } catch (error) {
            console.error('Portal error:', error);
            return { ok: false, error: error.message };
        }
    }
};

